import { TimeFormatOptions, MobileBottomMenuView, CustomerHaveEstoniaPersonalCode } from "@nxplatform/helpers/entities";
import { DateFormat, GameImageSizeName, ImageAspectRatio, LoginTypes } from "@nxplatform/platform-entities";
import { AppStorage } from "@service/api-client/http/helpers/AppStorage";
import { LOCATION_SMART_TIMEOUT } from "@nxplatform/helpers/constants";
import { RegistrationStepForm } from "@nxplatform/platform-entities/customer/customer-enum-types";
const initialLimitsSet = {
  deposit: false,
  loss: false,
  session: false,
  balance: false,
  singleBet: false,
  wagerPerPeriod: false,
  selfExclusionEnabled: false,
  fixedSelfExclusion: {
    enabled: false,
    minDate: null,
    maxDate: null
  },
  accountDeactivation: {
    active: false,
    showSelfDeleteInMyAccount: false
  },
  timeoutLimitEnabled: false,
  balanceResidual: false
};
const CountryConfirmationFlag = "country_confirmed";
const initialPlatformSettingsState = {
  casino: {
    enabled: null,
    liveEnabled: null,
    showTopWinners: null,
    playersOnline: {
      enabledOnWeb: false,
      enabledOnMobApp: false
    },
    rtp: {
      enabled: false,
      period: ""
    }
  },
  sportsbook: null,
  limitsDisablable: {
    deposit: true,
    loss: true,
    wagerPerPeriod: true,
    session: true,
    balance: true,
    singleBet: true,
    balanceResidual: true,
    timeout: true
  },
  scriptsLoaded: false,
  certification: {
    displayHideBalanceOption: false,
    limitsRedirect: {},
    countryLimitsSettings: {},
    limitsDeposit: {}
  },
  login: [LoginTypes.email],
  limits: initialLimitsSet,
  pgw: {
    merchant_id: null,
    widget_countries: []
  },
  integrations: {
    neccton: {
      picBaseHost: null
    }
  },
  useSockets: false,
  isGrpcEnabled: false,
  termsAcceptRequired: false,
  loaded: false,
  leaguesWithSportIcon: [],
  isTextPage: window.isTextPage || false,
  isFrontRenderTextPage: window.isFrontRender || false,
  error: null,
  inactivityLogoutPeriod: null,
  layoutIsFrozen: false,
  footer: {},
  header: {},
  logo: {
    logoUrlDesktop: ""
  },
  loaderBackgroundColor: null,
  activePersonalCode: CustomerHaveEstoniaPersonalCode.no,
  customerApprovedModalState: AppStorage.get(CountryConfirmationFlag),
  visibleMobileAppElements: [],
  vipSportProgramImages: {},
  vipCasinoProgramImages: {},
  isNewSmartIdRegistration: false,
  showOccupationField: false,
  showSupportLinkOnCashier: false,
  saveSelectedBonusInCashier: false,
  bettingHistoryLimitedP3M: false,
  forecastHistoryLimitedP3M: false,
  isRedesignNotificationModalEnabled: false,
  isModernSelfExclusion: false,
  showZeroDepositLimitModal: false,
  isRedesignRestorePasswordFormEnabled: false,
  showLocalTime: false,
  showSessionTime: false,
  showLastLogInTime: false,
  defaultCurrency: null,
  menuLimitsAvailable: true,
  templatesVisible: false,
  siteMenuAdditionalItems: [],
  showCasinoSessionHistory: false,
  showExtendedTransactionHistory: false,
  showBetSettingsDescription: false,
  componentLoaderIcon: "",
  componentLoaderImage: "",
  showResponsibleGamingPopup: false,
  cashierEnableSelectorCurrency: false,
  newCashier: {
    enabled: false,
    theme: "dark"
  },
  authorisation: {
    isFitToPlayRequired: false,
    authProviders: null
  },
  locationSmart: {},
  locationSmartTimeout: LOCATION_SMART_TIMEOUT,
  referralsLink: "",
  homePageBannerLinks: {},
  ambassadorsLink: "",
  vipProgramBanners: {
    mobile: "",
    desktop: ""
  },
  sport: null,
  hallOfFame: null,
  resultsDisabled: null,
  customLinkInHeaderMenu: null,
  sportSettings: {
    oddsFormatPickerEnabled: true,
    acceptBetsPickerEnabled: true,
    lastBetSumToggleEnabled: true,
    fastSumPickerEnabled: false,
    quickBetToggleEnabled: false,
    hideCompetitorsLogos: false
  },
  showCasinoDemoGames: false,
  qrCodeImageLinkAppDownload: "",
  mobileAppDownloadLinkIos: null,
  newMainPage: {
    enabled: false
  },
  preselectedBonusType: null,
  customerSlideForMainPageBanner: {},
  promoOfferPopup: {
    enabled: false
  },
  categoryRecentlyPlayedEnabled: false,
  isShowCasinoBg: false,
  zingRecommendations: {
    enabled: false
  },
  casinoAggregatedCategoryEnabled: false,
  imageForPromotionPage: "",
  combisEnabled: true,
  boostedOddsEnabled: true,
  unselectCashierDepositBonus: false,
  phoneMarketingAllowedDisabled: false,
  newMarketingPreferencesEnabled: false,
  newMarketingPreferences: {
    phoneEnabled: true,
    emailEnabled: true,
    otherEnabled: false,
    smsEnabled: false,
    callsEnabled: false
  },
  display: {},
  casinoLiveBannerImages: {},
  casinoLineBannerImages: {},
  wheelOfFortuneEnabled: false,
  producerIconUrl: null,
  bonusesEnabled: true,
  isBlockedVip: false,
  bannersFromCms: false,
  pageExist: true,
  asia: {
    enabled: false
  },
  vipSportCustomRewards: false,
  refProgramEnabled: false,
  isUserRestrictionsAvailable: false,
  showNecctonNotificationEnabled: false,
  showTreshholdHitSnackEnabled: false,
  apiRenderComponents: {},
  newTopMenu: false,
  mobileCustomBanner: true,
  mobileCustomBannerLastWin: false,
  customRegistrationBannerImages: null,
  emailHintsEnabled: false,
  emailHints: null,
  mobileBottomMenu: {
    enabled: true,
    view: MobileBottomMenuView.default
  },
  nonAuthTimestamp: {
    timeZone: null,
    timeFormat: TimeFormatOptions.TIME_FORMAT_12
  },
  vrButtonInMenuEnabled: false,
  casinoVipLevelsCount: 15,
  verificationBlockFromCms: false,
  selfExclusionBlockFromCms: false,
  newBannersFromCms: false,
  casinoMobBotMenu: {
    enabled: false
  },
  slotUi: {
    enabled: true,
    showCoins: false,
    showWager: false,
    menu: {
      nonAuthUser: ["popular", "new"],
      authUser: {
        recent: {
          alternative: "popular"
        },
        favorite: {
          alternative: "new"
        },
        forYou: {
          alternative: null
        }
      }
    }
  },
  casinoDemoRealSwitch: true,
  newOndatoVerificationPageEnabled: false,
  bonusHub: {
    enabledOnMobile: false,
    bonusPrizeOnMobile: false,
    smarticoOnMobile: false,
    smarticoOnDesktop: false
  },
  showRandomSlot: false,
  showCryptoCurrencies: false,
  residualLimitDisableMockVersion1: false,
  requiredFieldsFromCashier: false,
  checkCashierNotification: false,
  cryptoCurrencyEnabled: false,
  bluemRgSmartAssistantEnabled: false,
  iFinanceCheckEnabled: false,
  showVideoBanner: false,
  configurablePersonalDetails: {},
  isConfigurableCashierEnabled: false,
  showWheelOnStart: false,
  wheelOfFortuneSkin: null,
  defaultWheelNonAuth: "bronze",
  gameImageCfg: {
    aspectRatio: ImageAspectRatio.ar4x3,
    imageSize: GameImageSizeName.normal
  },
  isMaterial: false,
  floatingLabel: false,
  isMaterialRegistration: false,
  customInputValidation: {
    enabled: false,
    allowedValidation: [
      RegistrationStepForm.password,
      RegistrationStepForm.email,
      RegistrationStepForm.city
    ]
  },
  isModalClosableOnSwipe: false,
  bluemRgSmartAssistantSdkApiUrl: "",
  gamixterEnabled: false,
  dobFormat: [
    DateFormat.day,
    DateFormat.month,
    DateFormat.year
  ],
  showCasinoDropdownsInAsideMenu: false,
  smarticoEnabled: false,
  checkCashierConfig: false,
  gamixterSettings: {
    lootBoxEnabled: false
  },
  cashbackWidgetSettings: {
    modal: {
      sportProgressIcon: null,
      casinoProgressIcon: null
    },
    miniWidget: {
      sportProgressIcon: null,
      casinoProgressIcon: null
    }
  },
  notificationsEnabled: false,
  pageSectionsConfig: null,
  showLastWinners: {
    casinoPage: true,
    liveCasinoPage: true
  },
  pwaInstallButtonSettings: {
    src: null,
    enabled: false
  },
  disableDemoGameForProviders: null,
  registrationBaseAutoScroll: false,
  useNewDobAutofocus: false,
  ondatoVerificationPopupInCasier: false,
  casinoMaxBetPopup: false,
  showRegFormOnStart: {
    enabled: false,
    startDelay: 30,
    inactivityDelay: 15,
    excludedPaths: []
  },
  personalPreferencesSettings: {
    enableCustomerSecuritySettings: false,
    enableBonusSettings: false
  },
  casinoPageRedesigned: false,
  restyledPagesEnabled: {
    allCasinoProviders: false,
    allCasinoCategories: false,
    forYouCategoryCasino: false,
    forYouCategoryLiveCasino: false,
    allProducerModalWindow: false,
    allGamesPages: false,
    gameErrorPopupEnabled: false
  },
  gamePreloaderImages: {},
  registrationSuccessLogoUrl: null,
  enableWelcomeLogin: false,
  restrictionConfirmationPopup: {
    selfExclusion: false,
    fixedSelfExclusion: false,
    selfDelete: false,
    coolingOff: false
  },
  fastDeposit: false,
  disableSportsBetting: false,
  fullSettingsLoaded: false,
  prizeHubEnabled: false,
  smarticoActions: false,
  animatedSignUpButton: false,
  slotsgemRegLoginAdjustments: {
    loginEnabled: false
  }
};
export {
  CountryConfirmationFlag,
  initialPlatformSettingsState
};
